import { useQuery } from '@/helpers/useQuery';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import FirstAidForm from './components/coachFirstAidPage/FirstAidForm';

import { useCoachSelf } from '@/data/coach';
import { useApplication } from '@/data/application';

const CoachFirstAidPage = () => {
  const coach = useCoachSelf();
  const coachActivityId = useQuery('coachActivityId');
  const applicationStructure = useApplication({ coachActivityId });

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }

  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton to={`/application/${coachActivityId}`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>First Aid</CardTitle>
        </CardHeader>
        <CardContent>
          <h3>First Aid</h3>
          <span className="text-muted-foreground">
            A basic First Aid certification is required to become a ProFound
            Pro. Please upload a copy of your First Aid certification.
          </span>
          <FirstAidForm />
        </CardContent>
      </Card>
    </Page>
  );
};

export default CoachFirstAidPage;
